export const IconFolderOpen = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconFolderOpen_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconFolderOpen_svg__a)">
        <path d="M4 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h5.175a1.98 1.98 0 0 1 1.4.575L12 6h9q.424 0 .712.287Q22 6.576 22 7q0 .424-.288.713A.97.97 0 0 1 21 8h-9.825l-2-2H4v12l1.975-6.575q.2-.65.738-1.038A2 2 0 0 1 7.9 10h12.9q1.024 0 1.613.813.587.812.312 1.762l-1.8 6a1.95 1.95 0 0 1-.738 1.038A2 2 0 0 1 19 20zm2.1-2H19l1.8-6H7.9z" />
      </g>
    </svg>
  );
};
